<div class="row">
  <h3 class="warning"><b>Are you still there?</b></h3>
  <p class="message">You will be automatically logged out due to inactivity in:</p>
  <p class="counter" [ngStyle]="{'color': timeRemaining <= 10 ? 'red' : 'black'}"><b>{{ counterString }}</b></p>
  <div class="buttonContainer">
    <button mat-button class="mat-raised-button mat-warn" id="logoutButton" (click)="logoutSelected()">Logout</button>
    <button mat-button class="mat-raised-button mat-davinci" id="cancel" (click)="userReturned()">Keep Working</button>
  </div>
</div>
